(function () {
    function initMainCart(sectionElement) {
        if (!sectionElement || sectionElement.dataset.mainCartInitialized === 'true') {
            return;
        }

        sectionElement.dataset.mainCartInitialized = 'true';

        sectionElement.addEventListener('click', function (event) {
            var minusButton = event.target.closest('[data-cart-page-quantity-minus]');
            var plusButton = event.target.closest('[data-cart-page-quantity-plus]');

            if (!minusButton && !plusButton) {
                return;
            }

            var stepper = event.target.closest('[data-cart-page-quantity]');
            var input = stepper ? stepper.querySelector('[data-cart-page-quantity-input]') : null;
            var form = input ? input.closest('form') : null;
            var updateButton = form ? form.querySelector('button[name="update"]') : null;

            if (!input || !form) {
                return;
            }

            var currentValue = Number(input.value) || 0;
            var nextValue = plusButton ? currentValue + 1 : Math.max(currentValue - 1, 0);

            input.value = nextValue;

            if (typeof form.requestSubmit === 'function') {
                form.requestSubmit(updateButton || undefined);
            } else {
                form.submit();
            }
        });
    }

    document.addEventListener('DOMContentLoaded', function () {
        document.querySelectorAll('[data-main-cart]').forEach(initMainCart);
    });

    document.addEventListener('shopify:section:load', function (event) {
        var sectionElement = event.target.matches && event.target.matches('[data-main-cart]')
            ? event.target
            : event.target.querySelector && event.target.querySelector('[data-main-cart]');

        initMainCart(sectionElement);
    });
})();
